/**
 * Fiyat gösterim biçimlendirme — Türkçe konvansiyon (binlik nokta, ondalık virgül).
 *
 * ÖNEMLİ: Gateway decimal string'i OTORİTEDİR (bcmath/decimal.js ile hesaplanmış).
 * Burada YALNIZCA gösterim biçimlendirilir; hesaplama/yuvarlama yapılmaz → precision
 * bozulmaz. Ham string'in ondalık hane sayısı korunur (gateway sembol başına yuvarlar).
 *
 * Faz 1.18 O1: cell/list/ticker hepsi tek noktadan biçimlendirir (tutarlı ondalık + ayraç).
 */

const PLACEHOLDER = '—';

/**
 * Ham decimal string → "1.234,50" (tr-TR). Geçersiz/boş → '—'.
 * Gelen string'in ondalık hane sayısını AYNEN korur (gateway otoritesi).
 */
export function formatPrice(value: string | number | undefined | null): string {
    if (value === undefined || value === null || value === '') return PLACEHOLDER;
    const str = String(value).trim();
    const num = Number(str);
    if (!Number.isFinite(num)) return PLACEHOLDER;

    // Gelen ham string'in ondalık hane sayısını koru (gateway sembol bazında yuvarlar).
    const dot = str.indexOf('.');
    let fractionDigits = dot >= 0 ? str.length - dot - 1 : 0;

    // Ondalık tamamen sıfırsa gizle (örn. "10526.00" → "10.526"); anlamlı ondalık korunur
    // ("6457.29" → "6.457,29"). Kullanıcı isteği: ",00" gösterme.
    if (fractionDigits > 0 && /^0+$/.test(str.slice(dot + 1))) {
        fractionDigits = 0;
    }

    return num.toLocaleString('tr-TR', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
}

/** Makas (spread) gibi türetilmiş gösterim değerleri için — en fazla 2 ondalık. */
export function formatDelta(value: number): string {
    return value.toLocaleString('tr-TR', { maximumFractionDigits: 2 });
}

export { PLACEHOLDER as PRICE_PLACEHOLDER };
